module.exports = __webpack_public_path__ + "static/02-6edeef1765219ef143d89216e69a37be.png";